import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import '../../../assets/css/uploadReport.scss'
import Select from 'react-select';
import { Col, Row } from "react-bootstrap";
import { ClearBtn, SearchBtn } from "../../Buttons/Buttons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadGetReports, loadGetUploadUser } from "../../redux/action";
import { Skeleton } from "@mui/material";

const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 }
];

const startYear = 2020;
const currentYear = new Date().getFullYear();

const Years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
    const year = startYear + i;
    return { label: year.toString(), value: year };
});

const UploadReport = () => {
    const dispatch = useDispatch();
    const { getDataReport } = useSelector(state => state.data);
    const { getUploadUser } = useSelector(state => state.data);
    const { loading } = useSelector(state => state.data);
    console.log(loading)

    const [getReports, setGetReports] = useState([])
    const [getTotalReport, setTotalReport] =  useState();
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);

    useEffect(() => {
        dispatch(loadGetUploadUser());
        fetchReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchReportData = () => {
        dispatch(loadGetReports(selectedUser === null ? 0 : selectedUser?.value, selectedMonth === null ? 0 : selectedMonth?.value, selectedYear === null ? 0 : selectedYear?.value));
    }

    useEffect(() => {
        if(Object.keys(getDataReport).length !== 0){
            setGetReports(getDataReport.data);
            setTotalReport(getDataReport.total_summary);
        }
    }, [getDataReport])

    const searchData = () => {
        fetchReportData();
    }

    const clearFilters = () => {
        setSelectedUser(null);
        setSelectedMonth(null);
        setSelectedYear(null);
        setTimeout(() => {
                fetchReportData(); // Will pick up the latest state
            }, 100);
    }

    return (
        <div className='page-layout'>
            <AppNavbar />
            <div className='page-content'>
                <div className="upload-report-container">
                    <div className="upload-report-container-header">
                        <div className="upload-report-count"><h6>Upload Count <p> {getTotalReport?.total_data_count}</p></h6></div>
                        <Row className="m-0">
                            <Col md={2} className="pe-0">
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={getUploadUser}
                                    value={selectedUser}
                                    onChange={(e) => setSelectedUser(e)}
                                    placeholder="Select user" />
                            </Col>
                            <Col md={2} className="pe-0">
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={months}
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e)}
                                    placeholder="Select month" />
                            </Col>
                            <Col md={2} className="pe-0">
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={Years}
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e)}
                                    placeholder="Select Years" />
                            </Col>
                            <Col md="auto pe-0">
                                <SearchBtn btnName='Search' onClickEffect={searchData} />
                            </Col>
                            <Col md="auto pe-0">
                                <ClearBtn btnName='Clear' onClickEffect={clearFilters} />
                            </Col>
                        </Row>
                        <div className="upload-report-card-container">
                            <Row className="mt-4 m-0">
                                {loading ? 
                                <>
                                    {
                                        Array.from({ length: 20 }).map((_, index) => {
                                        return <Col md={3} key={index} className="pb-2" style={{height: "120px"}}>
                                                <Skeleton className="custom_skeleton" />
                                        </Col>
                                    })}
                                </>
                                :
                                <>
                                {getReports.length !== 0 ? 
                                <>
                                    {
                                        getReports.map((item, index) => {
                                        return <Col md={3} key={index} className="pb-2">
                                            <div className="summary-card">
                                                <h5 className="summary-card-title">{item.month_name}-{item.year}</h5>
                                                <div className="summary-card-content">
                                                    <div className="summary-item">
                                                        <div className="label total-count-label">Total Count</div>
                                                        <div className="value total-count">{item.total_data_count}</div>
                                                    </div>
                                                    <div className="summary-item">
                                                        <div className="label">Accepted</div>
                                                        <div className="value accepted-count">{item.accepted_data_count}</div>
                                                    </div>
                                                    <div className="summary-item">
                                                        <div className="label">Rejected</div>
                                                        <div className="value rejected-count">{item.rejected_data_count}</div>
                                                    </div>
                                                    <div className="summary-item">
                                                        <div className="label">Country</div>
                                                        <div className="value">{item.country_data_count}</div>
                                                    </div>
                                                    <div className="summary-item">
                                                        <div className="label">Industry</div>
                                                        <div className="value">{item.industry_data_count}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    })}
                                </>
                                :
                                <>
                                    <h5>No data found</h5>
                                </>
                                }
                                </>
                                }
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default UploadReport;